import { Component, h, tag } from "omi";
import classNames from "classnames";

import { useTocStore } from "@/wc/pages/project/ui/tableOfContent/store";
import { NWButton } from "@/wc/components/atoms/nw-button";
import { useEditorController } from "@/wc/editor/useEditor.ts";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {
  nodeType: string;
  nodeId: string;
  editorInstanceId: string;
  active: boolean;
};

@tag("nw-bookmark-btn")
export class NWBookmarkBtn extends Component<Props> {
  static css = [tailwind];

  static defaultProps = {
    active: false,
  };

  static propTypes = {
    nodeType: String,
    nodeId: String,
    editorInstanceId: String,
    active: Boolean,
  };

  private handleOnClick = () => {
    Store.editor.setActiveInstanceId(this.props.editorInstanceId);
    useEditorController()?.toggleBookmark(this.props.editorInstanceId, this.props.nodeId);
    useTocStore().setLatestBookmark(this.props.nodeId);
  };

  render() {
    return (
      <div className={classNames("mr-2", { "z-[11]": this.props.active })}>
        <NWButton
          size="icon"
          type="icon"
          icon="bookmark"
          iconSize="md"
          iconColor={this.props.active ? "text-primary" : undefined}
          onClick={this.handleOnClick}
        />
      </div>
    );
  }
}
